import { apiOps } from '../../api/defs/apiOps'
import { HigherApiClient } from '../../api/client/ApiClient'
import { getCachedCoords, getGeolocation } from '../../geo/locationService'
import { Coordinates } from 'src/api/defs/Coordinates.type'

const ops = apiOps.ClientLockV2

type UnlockOpts = {
    entryWithoutGPS?: boolean
    locationOverride?: Coordinates
}

export class UserCommonLockApi {
    constructor(private api: HigherApiClient) {}

    private async buildClientLocation(useCache?: boolean, opts?: UnlockOpts) {
        if (opts?.locationOverride) return opts.locationOverride

        // Prefer a valid cached location first for unlock latency.
        // Fresh geolocation refresh can happen in background.
        const cachedCoords = getCachedCoords()
        if (cachedCoords) return cachedCoords

        if (opts?.entryWithoutGPS) {
            try {
                return await getGeolocation(true)
            } catch {
                return { lat: 0, lng: 0 }
            }
        }
        return await getGeolocation(!!useCache)
    }

    unlockBox = async (
        id: number,
        useCache?: boolean,
        opts: UnlockOpts = {}
    ): Promise<number> =>
        this.api.do<number>(ops.unlockBox, {
            pathParams: { id },
            data: await this.buildClientLocation(useCache, opts),
            queryParams: {
                entryWithoutGPS: opts.entryWithoutGPS ? 'true' : 'false'
            }
        })

    unlockWarehouse = async (
        id: number,
        useCache?: boolean,
        opts: UnlockOpts = {}
    ): Promise<number> =>
        this.api.do<number>(ops.unlockWarehouse, {
            pathParams: { id },
            data: await this.buildClientLocation(useCache, opts),
            queryParams: {
                entryWithoutGPS: opts.entryWithoutGPS ? 'true' : 'false'
            }
        })

    unlockBackupWarehouse = async (
        id: number,
        useCache?: boolean,
        opts: UnlockOpts = {}
    ): Promise<number> =>
        this.api.do<number>(ops.unlockBackupWarehouse, {
            pathParams: { id },
            data: await this.buildClientLocation(useCache, opts)
        })
}
